import * as React from "react";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { red } from "@mui/material/colors";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShareIcon from "@mui/icons-material/Share";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import useBlogCalls from "../../service/useBlogCalls";
import { useSelector } from "react-redux";
import { MdVisibility } from "react-icons/md";
import { textAlign } from "@mui/system";
import BlogModal from "./BlogModal";
import { useState } from "react";
import Swal from "sweetalert2";

export default function BlogCard({ item, userId }) {
  // console.log("🚀 ~ BlogCard ~ item:", item);
  const navigate = useNavigate();
  const { postLikeBlog, deleteBlog } = useBlogCalls();
  const user = useSelector((state) => state.auth);
  // console.log("🚀 ~ BlogCard ~ user:", user);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };
  const handleDelete = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          icon: "success",
        });
        deleteBlog(item._id);
      }
    });
  };

  return (
    <Card
      sx={{
        maxWidth: 345,
        minWidth: 300,
        marginBottom: "3rem",

        height: userId ? 620 : 570,
        mx: "auto",
        p: "1rem",
        backgroundColor: "RGBA(43,45,66,0.8)",
        color: "white",
      }}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        boxShadow: "10px 5px 20px 5px RGBA(43,45,66)",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {userId && (
          <Button
            color={item.isPublish ? "primary" : "error"}
            variant="contained"
            sx={{ marginBottom: "1rem", width: "200px" }}
            onClick={handleOpen}
          >
            {userId
              ? item.isPublish
                ? "Publish-update"
                : "Draft-update"
              : undefined}
          </Button>
        )}
        {userId && (
          <Button
            color={"error"}
            variant="contained"
            sx={{ marginBottom: "1rem", width: "100px" }}
            onClick={handleDelete}
          >
            Delete
          </Button>
        )}
      </div>
      {/* {userId && (
        <Button
          color={item.isPublish ? "primary" : "error"}
          variant="contained"
          sx={{ marginBottom: "1rem" }}
          onClick={handleOpen}
        >
          {userId
            ? item.isPublish
              ? "Publish-update"
              : "Draft-update"
            : undefined}
        </Button>
      )} */}
      <div className="imageContainer">
        <img
          src={item.image}
          alt={item.title}
          style={{ objectFit: "cover", height: "300px", width: "100%" }}
        />
        {/* <div className="desc">
          <p>{item.content}</p>
        </div> */}
      </div>

      <CardContent>
        <Typography
          className="clamp-text"
          variant="body2"
          style={{
            textAlign: "center",
            fontSize: "1rem",
            textTransform: "uppercase",
          }}
        >
          {item.title}
        </Typography>
        <Typography variant="body2" className="clamp-text">
          {item.content}
        </Typography>
      </CardContent>

      <CardActions
        style={{ display: "flex", justifyContent: "space-around", px: "1rem" }}
      >
        <Stack direction="row" spacing={1}>
          <IconButton
            disabled={!user.token}
            aria-label="add to favorites"
            sx={{
              color:
                user.token && item.likes.includes(user.userId) > 0
                  ? "#ff1744"
                  : user.token
                  ? "grey"
                  : "red", // Etkin olmadığında "red" renk
            }}
          >
            <FavoriteIcon onClick={() => postLikeBlog(item._id)} />{" "}
            {item?.likes.length || 0}
          </IconButton>
          <IconButton style={{ color: "white" }}>
            <ChatBubbleOutlineIcon
              style={{ fontSize: "1.5rem", color: "white", marginRight: "6px" }}
              // onClick={() => deleteBlog(`${item._id}`)}
            />
            {item?.comments?.length || 0}
          </IconButton>
          <IconButton style={{ color: "white" }}>
            <MdVisibility />
            {item.countOfVisitors}
          </IconButton>
        </Stack>

        <div>
          <Button
            onClick={() =>
              // deleteBlog(item._id)
              navigate(`/blogdetailed/${item._id}`)
            }
            variant="contained"
            sx={{
              backgroundColor: red[500],
              "&:hover": { backgroundColor: red[800] },
              // width:"140px"
            }}

            // style={{transition:".5sn ease", "&:hover":{backgroundColor:"black"}}}
          >
            Read More
            <ReadMoreIcon />
          </Button>
          <BlogModal open={open} handleClose={handleClose} item={item} />
        </div>
      </CardActions>
    </Card>
  );
}
